import {useDispatch, useSelector} from "react-redux";
import Modal, {ModalCard} from "../../components/UIComponents/Modal";
import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {toggleAddFollowersModal} from "../../store/entities/submissionDetail";
import Button, {IconButton} from "../../components/UIComponents/Button";
import {Field, Label, Select} from "../../components/UIComponents/Form";
import {mdiCloseThick} from "@mdi/js";
import {addFollowers, getExternalFollowers, getSubmission} from "../../store/entities/submissionDetail/thunks";
import {notifySuccess} from "../../utils/notifications";
import {Section} from "../../components/UIComponents/Layout";


const AddFollowersFormModal = props => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const {reporters, addFollowersModalOpen} = useSelector(
    state => state.submissionDetail
  );
  const {submissionDetail} = useSelector(state => state.submissionDetail);
  const submissionId = submissionDetail?.id;

  const [selectedFollowers, setSelectedFollowers] = useState([]);

  const handleSelect = (option) => {
    if (!selectedFollowers.find(r => r.id === option.id)) {
      setSelectedFollowers([...selectedFollowers, option]);
    }
  };

  const removeReporter = (id) => {
    setSelectedFollowers(selectedFollowers.filter(r => r.id !== id));
  };

  const reporterOptions = useMemo(
    () =>
      reporters.map(reporter => ({
        id: reporter.id,
        value: reporter,
        label: `${reporter?.firstName} ${reporter?.lastName}`,
      })),
    [reporters]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    const followerIds = selectedFollowers.map(f => f.id);
    const resultAction = await dispatch(addFollowers({ submissionId, followerIds }));

    if (addFollowers.fulfilled.match(resultAction)) {
      notifySuccess(
          t('datagate.external.users.message.followers')
      );
      dispatch(toggleAddFollowersModal());
      dispatch(getSubmission(submissionId));
    }
  };

  useEffect(() => {
    const fetchFollowers = async () => {
      if (!addFollowersModalOpen || !submissionId) return;

      const result = await dispatch(getExternalFollowers({submissionId}));

      getExternalFollowers.fulfilled.match(result)
      const followers = result.payload || [];
      const formatted = followers.map(f => ({
        id: f.id,
        value: f,
        label: `${f.firstName} ${f.lastName}`,
      }));
      setSelectedFollowers(formatted);
    };

    fetchFollowers();
  }, [addFollowersModalOpen, submissionId, dispatch]);

  return (
    <Modal
      show={addFollowersModalOpen}
      onClose={() => dispatch(toggleAddFollowersModal())}
      {...props}
    >
      <ModalCard>
        <form onSubmit={handleSubmit}>
          <ModalCard.Head>
            <ModalCard.Title>
              <Label>
                {t('datagate.external.users.modal.followersSelect')}
              </Label>
            </ModalCard.Title>
          </ModalCard.Head>
          <ModalCard.Body>
            <Section className="vertical-padding-md" style={{paddingBottom: '6rem'}}>
              <Field style={{mb: '30px'}}>
                <Select
                  placeholder={t(
                    'datagate.external.users.modal.followersSelect.placeholder'
                  )}
                  options={reporterOptions}
                  onChange={handleSelect}
                  menuPortalTarget={null}
                />
              </Field>
              <>
                <ul>
                  {selectedFollowers.map((reporter) => (
                    <li key={reporter.id}
                        style={{display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px'}}>
                      {reporter.label}
                      <IconButton
                        path={mdiCloseThick}
                        size={0.9}
                        onClick={() => removeReporter(reporter.id)}
                        style={{cursor: 'pointer'}}
                        aria-label={`Remove ${reporter.label}`}
                      />
                    </li>
                  ))}
                </ul>
              </>
            </Section>
          </ModalCard.Body>

          <ModalCard.Foot style={{paddingTop: '40px'}}>
            <Button
              type="button"
              className="mb-3"
              color="primary"
              onClick={() => dispatch(toggleAddFollowersModal())}
              outlined
              id="cancelAddFollowersButton"
            >
              &#215; {t('datagate.external.global.cancel')}
            </Button>
            <Button
              type="submit"
              className="mb-3"
              color="primary"
              id="confirmAddFollowersButton"
            >
              {t('datagate.external.global.confirm')}
            </Button>
          </ModalCard.Foot>
        </form>
      </ModalCard>
    </Modal>
  )
};

export default AddFollowersFormModal;
